<template>
  <!-- 外层滚动容器，带垂直滚动进度条 -->
  <div class="page-scroll-wrap">
    <div class="survey-detail-wrap">
      <!-- 返回头部 -->
      <div class="page-header">
        <el-button icon="el-icon-arrow-left" link @click="goBack">返回列表</el-button>
      </div>
      <h2 class="page-title">
        {{ rowData._fromTab === 'collection' ? '租户问卷详细内容' : '问卷详细内容' }}
      </h2>

      <!-- 循环问卷大分组 -->
      <div
        v-for="group in surveyInfo.children"
        :key="group.uuid"
        class="section-block"
      >
        <!-- 分组标题：左侧绿色竖线 + 浅蓝背景 -->
        <div class="section-title">
          <span class="title-line"></span>
          {{ group.title }}
        </div>

        <!-- 循环当前分组下所有题目 -->
        <div v-for="question in group.children" :key="question.uuid" class="question-card">
          <div class="q-label">
            <!-- 青绿色圆角方块题号 -->
            <span class="q-num">{{ getQNum(question.title) }}</span>
            <span class="q-text">{{ clearQNum(question.title) }}</span>
          </div>

          <!-- 填空题 801303：纯文本展示 -->
          <div v-if="question.topicType === 801303" class="q-content">
            {{ fillTextMap[question.uuid] || "" }}
          </div>

          <!-- 单选801301 / 多选801302 选项区域 -->
          <div v-else class="q-option-group">
            <span
              v-for="opt in question.children"
              :key="opt.uuid"
              class="option-tag"
              :class="{ active: isOptionActive(question, opt.uuid) }"
            >
              {{ opt.title }}
            </span>
          </div>
        </div>
      </div>

      <!-- 底部提示文字 -->
      <div class="footer-tip">
        感谢租户的认真填写！我们将根据本次问卷反馈，逐一梳理问题、落实整改，全力为大家打造舒适、公正、优质的租住环境。
      </div>
    </div>
  </div>
</template>

<script>
import { detailFeedbackApi, detailLeasorFeedbackApi } from "@/api/online-survey";
export default {
  name: "SurveyDetail",
  data() {
    return {
      surveyInfo: null,
      // 选项选中映射：key=题目uuid，value=[选中选项uuid1, uuid2...]
      answerMap: {},
      // 填空文本单独存储：key=题目uuid，value=填写文字
      fillTextMap: {},
      rowData: {}
    };
  },
  mounted() {
    this.rowData = this.$route.params.rowData || {};
    console.log('路由传入rowData', this.rowData);
    this.fetchDetail();
  },
  methods: {
    // 统一分发请求
    fetchDetail() {
      // 每次请求清空旧数据，防止残留数据干扰
      this.surveyInfo = null;
      this.answerMap = {};
      this.fillTextMap = {};
      if (this.rowData._fromTab === 'collection') {
        this.getNormalDetail();
        this.getLeasorDetail();
      } else {
        this.getNormalDetail();
      }
    },
    // 生成全局loading
    createLoading() {
      return this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },
    // 普通问卷接口（标准树形结构）
    getNormalDetail() {
      const loading = this.createLoading();
      detailFeedbackApi({ uuid: this.rowData.uuid })
        .then(res => {
          console.log('普通问卷原始返回', res);
          this.surveyInfo = res.info;
          loading.close();
          this.$emit('handleSearch');
        })
        .catch(err => {
          console.error('普通问卷接口报错', err);
          loading.close();
        })
    },
    // 租户问卷核心转换方法
    getLeasorDetail() {
      const loading = this.createLoading();
      const reqUuid = this.rowData._originalUuid || this.rowData.uuid;
      detailLeasorFeedbackApi({ uuid: reqUuid })
        .then(res => {
          console.log('租户接口完整返回体', res);
          const info = res.info;
          const nodeList = info.feedbackNodes;

          // 遍历所有题目拆分数据
          const formatQuestions = nodeList.map(node => {
            const { uuid, title, topicType, items } = node;
            // 拆分填空 / 单选多选
            if (topicType === 801303) {
              // 填空题：兼容写法替代 items[0]?.title
              let fillStr = '';
              if (items && items.length > 0 && items[0].title !== undefined) {
                fillStr = items[0].title;
              }
              this.fillTextMap[uuid] = fillStr;
            } else {
              // 单选/多选：收集选中选项的uuid数组
              const selectOptUuids = [];
              if (items && items.length) {
                items.forEach(item => {
                  if (item.uuid) {
                    selectOptUuids.push(item.uuid);
                  }
                })
              }
              this.answerMap[uuid] = selectOptUuids;
            }

            // 构造标准题目结构
            const childList = [];
            if (items && items.length) {
              items.forEach(item => {
                childList.push({
                  uuid: item.uuid,
                  title: item.title
                })
              })
            }
            return {
              uuid,
              title,
              topicType,
              children: childList
            }
          })

          // 外层包装分组，兼容原有模板循环
          this.surveyInfo = {
            children: [
              {
                uuid: 'group_leasor_001',
                title: '租户问卷信息',
                children: formatQuestions
              }
            ]
          }

          console.log('转换后surveyInfo', this.surveyInfo);
          console.log('选项uuid映射answerMap', this.answerMap);
          console.log('填空文本映射fillTextMap', this.fillTextMap);
          loading.close();
          this.$emit('handleSearch');
        })
        .catch(err => {
          console.error('租户问卷接口异常', err);
          loading.close();
        })
    },

    // 通过选项uuid匹配是否选中（修正核心：不再对比文本）
    isOptionActive(question, optUuid) {
      const selectUuidArr = this.answerMap[question.uuid];
      if (!Array.isArray(selectUuidArr) || selectUuidArr.length === 0) return false;
      return selectUuidArr.includes(optUuid);
    },

    getQNum(title) {
      return title.split(".")[0];
    },
    clearQNum(title) {
      return title.split(".").slice(1).join(".");
    },
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
/* 样式完全不变，直接沿用 */
.page-scroll-wrap {
  width: 100%;
  height: calc(100vh - 60px);
  overflow-y: auto;
  overflow-x: hidden;
  padding: 10px;
  box-sizing: border-box;
}
.page-scroll-wrap::-webkit-scrollbar {
  width: 6px;
}
.page-scroll-wrap::-webkit-scrollbar-track {
  background: #f0f2f5;
  border-radius: 3px;
}
.page-scroll-wrap::-webkit-scrollbar-thumb {
  background: #c0c4cc;
  border-radius: 3px;
}
.page-scroll-wrap::-webkit-scrollbar-thumb:hover {
  background: #909399;
}

.survey-detail-wrap {
  padding: 10px;
  background: #fff;
  border-radius: 6px;
}
.page-header {
  margin-bottom: 12px;
}
.page-title {
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 24px 0;
  color: #333;
}

.section-block {
  margin-bottom: 22px;
  border-radius: 6px;
  overflow: hidden;
}
.section-title {
  position: relative;
  padding: 14px 16px 14px 24px;
  background-color: #e6f7ff;
  font-size: 16px;
  font-weight: 500;
  color: #54bcbd;
}
.title-line {
  position: absolute;
  left: 0;
  top: 0;
  width: 4px;
  height: 100%;
  background-color: #54bcbd;
}

.question-card {
  padding: 18px 20px;
  background: #ffffff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}
.question-card:not(:last-child) {
  margin-bottom: 12px;
}

.q-label {
  display: flex;
  align-items: center;
  margin-bottom: 14px;
  line-height: 1.6;
}
.q-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: #54bcbd;
  color: #fff;
  border-radius: 6px;
  font-size: 14px;
  margin-right: 10px;
  flex-shrink: 0;
}
.q-text {
  font-size: 15px;
  color: #333;
}

.q-content {
  padding-left: 38px;
  color: #444;
  line-height: 1.7;
}

.q-option-group {
  padding-left: 38px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.option-tag {
  padding: 7px 16px;
  border-radius: 6px;
  font-size: 14px;
  background: #f5f7fa;
  color: #888;
  white-space: nowrap;
}
.option-tag.active {
  border: 1px solid #94c7ff;
  background: #e6f2ff;
  color: #1677ff;
}

.footer-tip {
  margin-top: 36px;
  text-align: center;
  font-size: 13px;
  color: #999;
  line-height: 1.7;
}
</style>